module.exports = __webpack_public_path__ + "assets/fbbc7d5876d4c17de85a74e83c0ed57f.mp3";